const API_PATH = '/tops-offline-api/api/v1';

export function resolveBackendApiBaseUrl(): string {
  const origin = globalThis.location?.origin || '';
  const hostname = globalThis.location?.hostname || '';
  console.log(origin);
  console.log(hostname);
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return `http://localhost:8080${API_PATH}`;
  }

  return `${origin}${API_PATH}`;
}